import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="bg-gray-50 py-16 md:py-24" data-id="element-151">
      <div className="mx-auto max-w-4xl px-4" data-id="element-152">
        <div className="overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-gray-200" data-id="element-153">
          <div className="bg-gray-900 p-8 text-center text-white" data-id="element-154">
            <span className="mb-4 inline-block rounded-full bg-red-500 px-4 py-1 text-sm font-bold uppercase tracking-wider text-white animate-pulse" data-id="element-155">
              💥 OFERTA ESPECIAL
            </span>
            <h2 className="text-3xl font-black md:text-5xl" data-id="element-156">
              MEGA KIT SUPERVIVENCIA DOCENTE
            </h2>
            <p className="mt-4 text-gray-300" data-id="element-157">
              Sistema completo + 6 tomos + 3 bonos
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-158">
            <div className="mb-8 flex flex-col items-center justify-center gap-4" data-id="element-159">
              <p className="text-xl text-gray-500 line-through" data-id="element-160">
                Precio regular: $29.990
              </p>
              <div className="flex items-baseline gap-2" data-id="element-161">
                <span className="text-2xl font-bold text-gray-900" data-id="element-162">
                  Tu precio hoy:
                </span>
                <span className="text-6xl font-black text-green-600" data-id="element-163">
                  $19.990
                </span>
              </div>
            </div>

            <div className="mb-10 flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-600" data-id="element-164">
              <div className="flex items-center gap-2" data-id="element-165">
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-100" data-id="element-166">
                  <Check className="h-3 w-3 text-green-600" data-id="element-167" />
                </div>
                Pago único
              </div>
              <div className="flex items-center gap-2" data-id="element-168">
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-100" data-id="element-169">
                  <Check className="h-3 w-3 text-green-600" data-id="element-170" />
                </div>
                Acceso de por vida
              </div>
              <div className="flex items-center gap-2" data-id="element-171">
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-100" data-id="element-172">
                  <Check className="h-3 w-3 text-green-600" data-id="element-173" />
                </div>
                Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-174">
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-green-100" data-id="element-175">
                  <Check className="h-3 w-3 text-green-600" data-id="element-176" />
                </div>
                Sin suscripciones
              </div>
            </div>

            <CTAButton fullWidth className="text-2xl py-6 shadow-xl" onClick={() => {
            // Placeholder for external link
            console.log('Redirecting to checkout...');
            // window.location.href = 'CHECKOUT_URL';
          }} data-id="element-177">
              👉 SÍ, QUIERO EL MEGA KIT
            </CTAButton>

            <p className="mt-6 text-xs text-gray-400" data-id="element-178">
              Pagos seguros y encriptados. Acceso inmediato a tu email.
            </p>
          </div>
        </div>
      </div>
    </section>;
}